
import Header from '../components/general/Header'
import Footer from '../components/general/Footer'
import ContenidoActivarCuenta from '../components/cuentas/ContenidoActivarCuenta.jsx'
import MetaData from '../context/MetaData'

export default function Inicio(){
    return(
        <div>         
            <MetaData titulo="Activar Cuenta"/>
            <Header>            
            </Header>
            <ContenidoActivarCuenta></ContenidoActivarCuenta>
            <Footer></Footer>
        </div>
    );
}
